import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllSalesOrder(page,limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllSalesOrderByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanySalesOrder() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSalesOrderByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchSalesOrderDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneBySalesOrder/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchSalesOrderByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllSalesOrderByDealId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteSalesOrder(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteSalesOrder/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createSalesOrder(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSalesOrder`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateSalesOrder(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateSalesOrder/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createSalesOrder,
    updateSalesOrder,
    FetchAllSalesOrder,
    getCompanySalesOrder,
    FetchSalesOrderDetails,
    FetchSalesOrderByDeal,
    deleteSalesOrder,
}